import React, { useEffect } from "react";
import GalleryImage from "assets/svgIcons/CameraIcon";
import CampaignImage from "assets/svgIcons/TwoFlagIcon";
import { CommonButton } from "./CommonButton";
import { CommonHeading } from "./CommonHeading";
import { useHookstate } from "@hookstate/core";
import { MAP_GLOBAL_STATES } from "globalStore/globalStore";
import { Tooltip } from "@mui/material";
import { SubSideNavTabs } from "commonComponents/SideNav/subSideNav/subSideNavStyled";
import { useTranslation } from "react-i18next";
import { isUserReadOnly } from "constant";
import { useSelector } from "react-redux";

export const AdsSideNav = () => {
  const { t } = useTranslation();
  const { mapSideNavTabState } = useHookstate(MAP_GLOBAL_STATES);
  const {
    getUserRole,
  } = useSelector((state) => state.commonReducers);
  useEffect(() => {
    let getSubnavName = localStorage.getItem("mapSideNavTabState");
    if (getSubnavName == "Image Gallery" || getSubnavName == "Campaigns") {
      mapSideNavTabState.set(localStorage.getItem("mapSideNavTabState"));
    } else {
      mapSideNavTabState.set("Image Gallery");
      localStorage.setItem("mapSideNavTabState","Image Gallery")
    }
  }, []);

  return (
    <div style={{ padding: "10px" }}>
      <CommonHeading labelText={"Ads"} />
      <SubSideNavTabs>
        <Tooltip title={t("Image_gallery")} arrow>
          <span>
            <CommonButton
              labelText={"Image Gallery"}
              displayText={"Image_Gallery"}
              changeSideNavData={() => {
                localStorage.setItem("mapSideNavTabState", "Image Gallery");
                mapSideNavTabState.set("Image Gallery");
              }}
            >
              <GalleryImage
                color={
                  mapSideNavTabState.get() == "Image Gallery"
                    ? "var(--theme-text)"
                    : "var(--text-secondary)"
                }
              />
            </CommonButton>
          </span>
        </Tooltip>
        <Tooltip title={t("Campaigns")} arrow>
            <CommonButton
              labelText={"Campaigns"}
              displayText={"Campaigns"}
              changeSideNavData={() => {
                localStorage.setItem("mapSideNavTabState", "Campaigns");
                mapSideNavTabState.set("Campaigns");
              }}
            >
              <CampaignImage
                color={
                  mapSideNavTabState.get() == "Campaigns"
                    ? "var(--theme-text)"
                    : "var(--text-secondary)"
                }
              />
            </CommonButton>
        </Tooltip>
      </SubSideNavTabs>
    </div>
  );
};
